<template>
  <b-modal
    id="delete-item-modal"
    title="Delete Item"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to delete {{ name }}?
    </h4>
    <b-button
      variant="danger"
      block
      :disabled="deletingItem"
      @click="deleteItem"
    >
      <b-spinner
        v-if="deletingItem"
        small
      />
      <span v-else>Delete Item</span>
    </b-button>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const name = computed(() => props.item?.name?.en || '')

    const deletingItem = ref(false)
    const deleteItem = async () => {
      try {
        deletingItem.value = true
        await ctx.root.$store.dispatch('business/deleteItem', {
          itemId: props.item.id,
          payload: {
            businessId,
          },
        })
        ctx.root.$bvModal.hide('delete-item-modal')
        ctx.emit('item-deleted')
      } finally {
        deletingItem.value = false
      }
    }
    return {
      name,
      deleteItem,
      deletingItem,
    }
  },
}
</script>

  <style>

  </style>
